import { sendGTMEvent } from '@next/third-parties/google'
import pick from 'lodash/pick'

import { Message } from '@/types/message.type'
import { User } from '@/types/user.type'

// GTM forwards these to Amplitude through its own SDK, which privacyPlugin never sees, so the
// allowlists below are the only control: no direct identifiers (email, name) and no free text
// (message filters carry typed company, topic and keyword inputs).
const pickedUserFields = [
  'id',
  'provider',
  'status',
  'group',
  'confirmed_at',
  'free_trial_end_at',
  'roles',
  'language',
] as const

const pickedMessageFields = [
  'id',
  'conversation_id',
  'parent_message_id',
  'selected_model',
  'sender',
  'created_at',
  'status',
  'function_mode',
] as const

export const useGtmPush = () => {
  const setGtmUserProperties = (user: User | undefined | null) => {
    if (!user) return

    sendGTMEvent({
      event: 'set_user_properties',
      user_properties: {
        ...pick(user, pickedUserFields),
        organization_name: user.organization?.name,
        organization_id: user.organization?.id,
      },
    })
  }

  const sendUserMessageSentEvent = (message: Message) => {
    sendGTMEvent({
      event: 'user_message_sent',
      message_properties: pick(message, pickedMessageFields),
    })
  }

  const sendAgentResponseDeliveredEvent = (message: Message) => {
    sendGTMEvent({
      event: 'agent_response_delivered',
      message_properties: pick(message, pickedMessageFields),
    })
  }

  return {
    setGtmUserProperties,
    sendUserMessageSentEvent,
    sendAgentResponseDeliveredEvent,
  }
}
